<template>
		<div class="content" v-if="!notFound">
      <Header></Header>
      <div class="nav">
      	<span class="">{{$t('ruleTask')}}</span>
      </div>
      <div class="" style="padding-bottom: 30px;">
        <div class="task-list">
          <div class="task-c">
            <div class=" task-li app-en" v-for="(item,index) in list.task">
              <div class="">
                <div class="task-one1 fw7">{{item.title}}:</div>
                <div class="task-one2">
                  <span>{{item.desc}}</span>
                  <img v-if="item.status" width="30" src="../../static/images/select1.png">
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        <div class="task-list">
          <div class="task-c">
            <div class=" task-li app-en" v-for="(item,index) in list.rule">
              <div class="">
                <div class="task-one1 fw7">{{item.title}}:</div>
                <div class="task-one2">{{item.desc}}</div>
              </div>
            </div>
          </div>
        </div>-->
      </div>
		</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			notFound:false,
			list:{},
			page:1,
			limit:5,
      score:'',
			isShow:true,
      listMenu:['All','action','adventure','puzzle','sports'],
      noMore:''
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.push({path:'/'})
		},
		getHome(){
			let that =this;
      this.$parent.loadModal(true);
			let data = {
				page:that.page,
				//limit:that.limit,
			}
      this.noMore = that.$t('showMore')
			that.$api.post('/api/index/rule_task',data,r =>{
				that.$parent.returnCode(r,function(){
					that.$parent.loadModal(false);
          that.list = r.data
          return
					if(r.data.length>0){
						that.list = that.list.concat(r.data)
            console.log(that.list)
					}else{
						that.isShow = false;
            //that.noMore = that.$t('noMore')
						that.$utils.alertText(that.$t('noMore'));
					}

       });

			})
		},
		getMore(){
			let that = this;
			if(that.isShow){
				that.page++;
				that.getHome();
			}else{
				that.$utils.alertText(that.$t('noMore'));
			}
		},
	}
}
</script>
<style>
  .task-list{
    margin: 50px 50px 20px;
    background: #b8cbff57;
    padding: 10px 30px 30px;
    border-radius: 20px;}
  .task-li{color:#fff;border-bottom: 1px solid #ddd;padding: 20px 0;text-align: left;}
  .task-one1{color:#ffed9f;margin-bottom: 13px;}
</style>



// WEBPACK FOOTER //
// src/page/ruleTask.vue